import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SelectItem, SelectItemGroup, SortEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import {EventMonitoringFilter, EventsParams, FilterParams} from '../../models/events';
import { UsersState } from '../../store/reducers/user.reducers';
import { Observable, interval } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import { groupStr, PackageList, DisplaySourceType } from '../../shareModel';
import { Subject, combineLatest  } from 'rxjs';
import { ExcelService } from '../../services/excel.service';
import * as fromMyfeatures from '../../my-features';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { CryptoService } from '../../services/crypto.service';
import { MspRegion } from '../../my-features/region/region.model';
import { Router } from '@angular/router';
import * as fromFeature from '../../my-features';
import { DatePipe } from '@angular/common';
@Component({
  standalone: false,
  selector: 'app-event-monitoring',
  templateUrl: './event-monitoring.component.html',
  styleUrls: ['./event-monitoring.component.css'],
  providers: [DatePipe]
})
export class EventMonitoringComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.UI();
    this.InitialHeight();
  }
  @ViewChild('dt', { static: false }) table: Table;
  IsSuperAdmin = false;
  eventLogs_cols: any[] = [
    { field: 'status', header: 'Status', width: '80', class: 'col-nowrap text-center', disabled: false },
    { field: 'Account', header: 'Account', width: '250', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'DeviceSubType', header: 'Device Type', width: '180', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'formattedTime', header: 'Time', width: '170', class: 'col-nowrap', disabled: false },
    { field: 'timezoneLabel', header: 'Time Zone', width: '150', class: 'hidden-sm', disabled: false },
    { field: 'name', header: 'Device Name', width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'DisplaySourceTypeStr', header: 'Connection Type', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: 'Description', width: '420', class: 'col-nowrap', disabled: false },
  ];

  eventLogs_pro_cols: any[] = [
    { field: 'status', header: 'Status', width: '80', class: 'col-nowrap text-center', disabled: false },
    { field: 'Region', header: 'Company', width: '250', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'DeviceSubType', header: 'Device Type', width: '180', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'formattedTime', header: 'Time', width: '170', class: 'col-nowrap', disabled: false },
    { field: 'timezoneLabel', header: 'Time Zone', width: '150', class: 'hidden-sm', disabled: false },
    { field: 'name', header: 'Device Name', width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'DisplaySourceTypeStr', header: 'Connection Type', width: '200', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: 'Description', width: '420', class: 'col-nowrap', disabled: false },
  ];

  errorCode = false;
  errorCodeBg = '#d51f35'; // warning: #fdc503; critical: #d51f35;

  powerMaster = isODM;
  Confirm_button = Confirm_button;
  selectedRange: any = 1;
  statusOptions: SelectItem[] = [
    { label: 'Information', value: 0 },
    { label: 'Warning', value: 1 },
    { label: 'Critical', value: 2 },
    { label: 'Offline', value: 3 },
    { label: 'Hardware Status', value: 4 },
  ];
  pro_statusOptions: SelectItem[] = [
    { label: 'All', value: -1, title: '0'  },
    { label: 'Information', value: 0, title: '0' },
    { label: 'Warning', value: 1, title: '0' },
    { label: 'Critical', value: 2, title: '0' },
    { label: 'Offline', value: 3, title: '0' },
    { label: 'Hardware Status', value: 4, title: '0' },
  ];
  rangeOptions: SelectItem[] = [
    { label: '24 hr', value: 1 },
    { label: '3 Days', value: 3 },
    { label: '7 Days', value: 7 },
    { label: '30 Days', value: 30 },
    { label: '60 Days', value: 60 },
    { label: '90 Days', value: 90 }
  ];
  curDate = new Date();
  filterParam: EventMonitoringFilter = {
    // device_status: 2,
    startDate: new Date(this.curDate.getTime() - 24 * 60 * 60 * 1000),
    endDate: new Date()
  };
  device_status = 2;
  // eventLogs$: Observable<any>;
  eventLogs: any[];
  private componentDestroyed = new Subject();
  localTimeZone = new Date().getTimezoneOffset() / 60;
  CompanyOptions$: Observable<any>;

  // Pro Event
  proRegionId : number = 0;

  region: MspRegion[];
  treeRegion: any[] ;
  selectedRegion: any = null;
  ReadRegionParam: {
    MspMainRegionId: number
    otp: string;
  };
  selectedRegionName: string = '';
  selectedRegionId: number;
  pageLoading: boolean = true;
  regionEventDic = [];
  all_eventLogs = [];
  regionLoaded = false;
  isMsp = false;
  acode : number;
  treeRegionGrid_Region = [{}, {}, {}, {}, {}];

  constructor(private store: Store<fromStore.State>, private ngxService: NgxUiLoaderService, private excelService: ExcelService,
    private route: ActivatedRoute, private cryptoService: CryptoService, private router: Router, private datePipe: DatePipe
  ) {
    // Get User Info

    const hashStr = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashStr'));
    if (hashStr) {
      const params = hashStr.split(',');
      if (params !== undefined) {
        this.selectedRegionId = parseInt(params[0]);
        this.device_status = parseInt(params[1]);
      }
    }

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getRegions))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([getIsMspRes, getCurrentUserRes, region]) => {
        if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null) &&
          (region !== undefined && region !== null && region.length > 0)) {
          
            // Get IsMsp
            this.isMsp = getIsMspRes;
            this.IsSuperAdmin = getCurrentUserRes.authority === 2;
            if (this.IsSuperAdmin) {
                // 創建新對象以避免修改潛在的只讀對象 (NgRx 9 immutability)
                this.filterParam = { ...this.filterParam, regionId: getCurrentUserRes.RegionId };
            }
            if (
            this.isMsp && this.IsSuperAdmin === false) {
            const mspMainRegionItem = region.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);
            const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
            this.ReadRegionParam = {
              MspMainRegionId: mspMainRegionId,
              otp: ''
            };
            this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
            this.regionLoaded = true;
          }
          this.refresh();
        }
      })

    // Get Region List
    this.CompanyOptions$ = this.store.pipe(select(fromStore.getAllRegionsOptions));

    // Get Event List
    // this.eventLogs$ = this.store.pipe(select(fromStore.getEventMonitoringData));
    combineLatest(this.store.select(fromStore.getEventMonitoringData), this.store.select(fromStore.getEventMonitoringState))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([logs, state]) => {
        if (!state.Loading && state.Loaded) {
          this.eventLogs = [];
          this.all_eventLogs = [];
          if (logs !== undefined) {
            if (logs.length > 0) {
              logs = logs.map(log => {
                const formattedTime = (log.timestamp != null) ? this.datePipe.transform(
                    (log.timestamp * 1000) + ((this.localTimeZone + log.timeZone) * 60 * 60 * 1000),
                    'yyyy/MM/dd HH:mm:ss') : '';                
                return {
                  ...log,
                  DisplaySourceTypeStr: DisplaySourceType[log.DisplaySourceType] ? DisplaySourceType[log.DisplaySourceType].SubType : log.DisplaySourceType,
                  formattedTime: formattedTime // 建立新屬性
                };
              });
              
              this.all_eventLogs = logs;
              this.eventLogs = logs;
            }
            if (this.isMsp) {
              if (this.device_status == null) {
                this.device_status = 2;
              }
              if (this.device_status >= 0) {
                this.eventLogs = this.all_eventLogs.filter(e => e.statusCode == this.device_status);
              }
              this.regionEventDic = [];
              logs.map(e => {
                if (this.regionEventDic[e.RegionId] == undefined) {
                  this.regionEventDic[e.RegionId] = {
                    data: [],
                    all_count: 0,
                    normal_count: 0,
                    warning_count: 0,
                    critical_count: 0,
                    offline_count: 0,
                    hardware_status_count: 0
                  };
                }
                // 取出所有region的device後分群
                if (e.statusCode == 0) { // normal
                  this.regionEventDic[e.RegionId].normal_count += 1;
                } else if (e.statusCode == 1) { // warning
                  this.regionEventDic[e.RegionId].warning_count += 1;
                } else if (e.statusCode == 2) { // critical
                  this.regionEventDic[e.RegionId].critical_count += 1;
                } else if (e.statusCode == 3) { // offline
                  this.regionEventDic[e.RegionId].offline_count += 1;
                } else if (e.statusCode == 3) { // offline
                  this.regionEventDic[e.RegionId].hardware_status_count += 1;
                }
                this.regionEventDic[e.RegionId].all_count += 1;
                this.regionEventDic[e.RegionId].data.push(e)
              });
              this.getTreeRegion();
            }
            this.ngxService.stop();
            this.InitialHeight();
          }
        }
      })

    this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        this.region = res;
        this.getTreeRegion();
      }
    });

    this.errorCode = true;

    // Event Monitoring Filter
    this.store.select(fromStore.getEventMonitoringFilters).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (hashStr === undefined) {
        this.device_status = res;
      }
    });
  }

  ngOnInit() {
    this.UI();
    // this.store.dispatch(new fromFeature.GetMspRegions(this.ReadRegionParam));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }


  refresh() {
    this.ngxService.start();
    this.store.dispatch(new fromMyfeatures.GetEventMonitoring({ ...this.filterParam }));
  }

  changeStatus() {
    if (this.isMsp) {
      if (this.device_status >= 0 && this.selectedRegionId >= 0) {
        this.eventLogs = this.all_eventLogs.filter(e => e.RegionId === this.selectedRegionId && e.statusCode == this.device_status)
      } else if (this.selectedRegionId >= 0) {
        this.eventLogs = this.all_eventLogs.filter(e => e.RegionId === this.selectedRegionId)
      } else if (this.device_status >= 0) {
        this.eventLogs = this.all_eventLogs.filter(e => e.statusCode == this.device_status)
      } else {
        this.eventLogs = this.all_eventLogs;
      }
    } else {
      const params: EventMonitoringFilter = {
        device_status: this.device_status
      };
      this.store.dispatch(new fromMyfeatures.LoadEventFilterss(params));
    }
    this.table.reset();
  }

  dispatchRangeFilter() {
    this.filterParam = {
      ...this.filterParam,
      startDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * this.selectedRange),
    };
    this.refresh();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
  }

  InitialHeight() {
    const contentListHeight = document.getElementsByClassName('content-list')[0] as HTMLElement;
    if (contentListHeight !== undefined) {
      const mainListContent = self.innerHeight - 240 + 'px';
      contentListHeight.style.height = mainListContent;
    } 
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  onRegionSelect(event: any): void {
    this.selectedRegion = event.node;
  }

  onRegionUnselect(event: any): void {
    setTimeout(() => {
      this.selectedRegion = event.node;
    });
  }

  selectionRegionChange() {
    this.pageLoading = false;
    let none_evet_status_flag = false;
    if (this.selectedRegion) {
      this.filterParam = { ...this.filterParam, regionId: undefined };
      this.selectedRegionName = this.selectedRegion.data.RegionName;
      if (this.selectedRegion.data.Id > 0) {
        this.selectedRegionId = this.selectedRegion.data.Id;
        if (this.regionEventDic[this.selectedRegion.data.Id] !== undefined) {
          this.pro_statusOptions = [
            {label: 'All', value: -1, title: this.regionEventDic[this.selectedRegion.data.Id].all_count},
            {label: 'Normal', value: 0, title: this.regionEventDic[this.selectedRegion.data.Id].normal_count},
            {label: 'Warning', value: 1, title: this.regionEventDic[this.selectedRegion.data.Id].warning_count},
            {label: 'Critical', value: 2, title: this.regionEventDic[this.selectedRegion.data.Id].critical_count},
            {label: 'Offline', value: 3, title: this.regionEventDic[this.selectedRegion.data.Id].offline_count},
            {label: 'Hardware Status', value: 4, title: this.regionEventDic[this.selectedRegion.data.Id].hardware_status_count},
          ];
        } else {
          none_evet_status_flag = true;
        }
      } else {
        this.selectedRegionId = -1;
        if (this.treeRegion) {
          this.pro_statusOptions = [
            {label: 'All', value: -1, title: this.treeRegion[0].data.all_event_count},
            {label: 'Normal', value: 0, title: this.treeRegion[0].data.all_normal_event_count},
            {label: 'Warning', value: 1, title: this.treeRegion[0].data.all_warning_event_count},
            {label: 'Critical', value: 2, title: this.treeRegion[0].data.all_critical_event_count},
            {label: 'Offline', value: 3, title: this.treeRegion[0].data.all_offline_event_count},
            {label: 'Hardware Status', value: 4, title: this.treeRegion[0].data.all_hardware_status_event_count},
          ];
        } else {
          none_evet_status_flag = true;
        }
      }
      if (none_evet_status_flag) {
        
        this.pro_statusOptions = [
          {label: 'All', value: -1, title: '0'},
          {label: 'Normal', value: 0, title: '0'},
          {label: 'Warning', value: 1, title: '0'},
          {label: 'Critical', value: 2, title: '0'},
          {label: 'Offline', value: 3, title: '0'},
          {label: 'Hardware Status', value: 4, title: '0'}
        ];
      }
      this.refresh();
    }
  }

  // 將資料轉換成TreeTable格式
  getTreeRegion() {
    if (this.region !== undefined) {
      const regionMap = new Map<number, any>();
      this.treeRegion = this.region.map(i => ({
        data: {
          ...i,
          all_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].all_count : 0,
          normal_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].normal_count : 0,
          warning_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].warning_count : 0,
          critical_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].critical_count : 0,
          offline_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].offline_count : 0,
          hardware_status_event_count: (this.regionEventDic !== undefined && this.regionEventDic[i.Id] !== undefined) ? this.regionEventDic[i.Id].hardware_status_count : 0
        },
        children: [],
        expanded: true
      })) as any[];
  
      this.treeRegion.forEach(node => {
        regionMap.set(node.data.Id, node);
      });
  
      let transformedRegion: any[] = [];
      let all_event_count = 0;
      let all_normal_event_count = 0;
      let all_warning_event_count = 0;
      let all_critical_event_count = 0;
      let all_offline_event_count = 0;
      let all_hardware_status_event_count = 0;
      this.treeRegion.forEach(node => {
        all_event_count = all_event_count + node.data.all_event_count;
        all_normal_event_count = all_normal_event_count + node.data.normal_event_count;
        all_warning_event_count = all_warning_event_count + node.data.warning_event_count;
        all_critical_event_count = all_critical_event_count + node.data.critical_event_count;
        all_offline_event_count = all_offline_event_count + node.data.offline_event_count;
        all_hardware_status_event_count = all_hardware_status_event_count + node.data.hardware_status_event_count;
        const parentId = node.data.ParentRegionId;
        const mainRegionId = node.data.MspMainRegionId;
        if (node.data.Id === parentId || node.data.Id === mainRegionId) {
          transformedRegion.push(node);
        } else {
          const parentNode = regionMap.get(parentId);
          if (parentNode) {
            parentNode.children.push(node);
          } else {
            transformedRegion.push(node);
          }
        }
        if (this.selectedRegionId !== null && this.selectedRegionId !== -1 && this.selectedRegionId === node.data.Id) {
          this.selectedRegion = node;
          this.selectedRegionName = this.selectedRegion.data.RegionName;
          this.filterParam = { ...this.filterParam, regionId: undefined };
          this.pro_statusOptions = [
            {label: 'All', value: -1, title: node.data.all_event_count},
            {label: 'Normal', value: 0, title: node.data.normal_event_count},
            {label: 'Warning', value: 1, title: node.data.warning_event_count},
            {label: 'Critical', value: 2, title: node.data.critical_event_count},
            {label: 'Offline', value: 3, title: node.data.offline_event_count},
            {label: 'Hardware Status', value: 4, title: node.data.hardware_status_event_count}
          ];
          this.changeStatus();
        }
      });
  
      transformedRegion.unshift({
        data: {"Id": -1, 
          "RegionName": "All",
          "all_event_count": all_event_count,
          "all_normal_event_count": all_normal_event_count,
          "all_warning_event_count": all_warning_event_count,
          "all_critical_event_count": all_critical_event_count,
          "all_offline_event_count": all_offline_event_count,
          "all_hardware_status_event_count": all_hardware_status_event_count,
        },
        children: [],
        expanded: true
      });
  
      this.treeRegion = transformedRegion;
      // 預設選取第一筆資料
      if (this.treeRegion) {
        if (this.selectedRegionId === undefined || this.selectedRegionId === -1) {
          this.selectedRegion = this.treeRegion[0];
          this.selectedRegionName = this.selectedRegion.data.RegionName;
          this.filterParam = { ...this.filterParam, regionId: undefined };
          this.pro_statusOptions = [
            {label: 'All', value: -1, title: this.treeRegion[0].data.all_event_count},
            {label: 'Normal', value: 0, title: this.treeRegion[0].data.all_normal_event_count},
            {label: 'Warning', value: 1, title: this.treeRegion[0].data.all_warning_event_count},
            {label: 'Critical', value: 2, title: this.treeRegion[0].data.all_critical_event_count},
            {label: 'Offline', value: 3, title: this.treeRegion[0].data.all_offline_event_count},
            {label: 'Hardware Status', value: 4, title: this.treeRegion[0].data.all_hardware_status_event_count}
          ];
          this.selectedRegion = this.treeRegion[0];
          this.selectedRegionName = this.selectedRegion.data.RegionName;
          if (this.selectedRegion.data.Id > 0) {
            this.selectedRegionId = this.selectedRegion.data.Id;
          }
          this.filterParam = { ...this.filterParam, regionId: undefined };
        }
      }
    }
  }

  customSort(event: SortEvent) {
    const sortedData = [...event.data].sort((data1, data2) => {
      const value1 = this.getSortValue(data1[event.field], event.field);
      const value2 = this.getSortValue(data2[event.field], event.field);
      let result = null;
      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
      }
      return (event.order * result);
    });
    event.data = sortedData;
    this.eventLogs = sortedData;
  }

  private getSortValue(value: any, field: string): any {
    if (field === 'Account' && (value === '--' || value === '' || value == null)) {
      return null;
    }
    return value;
  }
}
